import * as signalR from '@microsoft/signalr';
import { SignalRClient } from '@/core/signalR/signalR.client';

const SIGNALR_URL = process.env.NODE_ENV === 'development' ? 'https://localhost:44342/chatHub' : 'https://titans-league.org/signalr/chat';
const SIGNALR_LOGLEVEL = process.env.NODE_ENV === 'development' ? signalR.LogLevel.Information : signalR.LogLevel.None;

export class ChatService extends SignalRClient {
    constructor() {
        super(SIGNALR_URL, SIGNALR_LOGLEVEL, false);
    }
}

export default new ChatService();
